import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/layouts/institucional/Elements/LegalDocument/index.tsx");
